import { createSlice } from "@reduxjs/toolkit";

const contractSlice = createSlice({
  name: "contract",
  initialState: {
    currentContractId: localStorage.getItem("currentContractId") || null,
  },
  reducers: {
    setCurrentContractId: (state, action) => {
      localStorage.setItem("currentContractId", action.payload);
      state.currentContractId = action.payload;
    },
    clearCurrentContractId: (state) => {
      localStorage.removeItem("currentContractId");
      state.currentContractId = null;
    }
  },
});

export const {
  setCurrentContractId,
  clearCurrentContractId
} = contractSlice.actions;
export default contractSlice.reducer;